import React from "react";

export default function PageHeader({ title, barColor = "#F6B829" }) {
  return (
    <header
      className="px-4 py-4 sticky top-0 z-40 rounded-xl"
      style={{ backgroundColor: barColor, color: "#ffffff" }}
      data-testid="page-header"
    >
      <h1 className="text-lg font-bold tracking-tight">{title}</h1>
    </header>
  );
}
